import React from 'react';
import { Header } from './components/Header';
import { Button } from './components/Button';
import { ServicesSection } from './sections/ServicesSection';
import { ProjectsSection } from './sections/ProjectsSection';
import { ContactSection } from './sections/ContactSection';
import './styles/App.css';

const base = process.env.PUBLIC_URL || '';

export function Home() {
   return (
      <>
         <div
            className="landing-with-sky"
            style={{
               background: `url(${base}/images/home/sky.jpg) center bottom / cover no-repeat`,
            }}
         >
            <div
               className="landing-pattern"
               style={{ backgroundImage: `url(${base}/images/home/bgpattern.png)` }}
               aria-hidden="true"
            />
            <Header />
            <section id="home" className="section-home" aria-label="Home">
               <div className="hero-content">
                  <h1 className="hero-title">
                     Welkom bij
                     <img
                        src={`${base}/images/home/logotext.png`}
                        alt="Dabra Development"
                        className="hero-title-logo"
                     />
                  </h1>
                  <p className="hero-subtitle">
                     Van idee tot werkende website!
                  </p>
                  <Button href="#contact" className="hero-cta">
                     Contact
                  </Button>
               </div>
            </section>
         </div>

         <main className="main-content">
            <ServicesSection />
            <div className="gradient-strip" aria-hidden="true" />
            <ProjectsSection />
            <ContactSection />
         </main>

         <footer className="site-footer">
            <a
               href="https://dabra-development.nl/"
               target="_blank"
               rel="noopener noreferrer"
               className="footer-logo"
            >
               <img src={`${base}/images/home/logotext.png`} alt="Dabra Development" />
            </a>
         </footer>
      </>
   );
}